import type { Beacon } from '@inspiren-monorepo/shared-types';

import { Api } from '../../../../../utility/client';

export const getBeaconAssignments = async (org: string) =>
  Api.get<Beacon[]>(`/v1/users/allBeaconUsers/${org}`);
